import React from 'react';
import PropTypes from 'prop-types';
import styles from './DocTile.module.scss';
import clsx from 'clsx';
import Progress from '../../../../components/style-guide/progress/Progress';
import OpenDocIcon from '../../../../components/style-guide/icons/OpenDoc.icon';
import DownloadDocIcon from '../../../../components/style-guide/icons/DownloadDoc.icon';
import eventBus from '../../../../service/eventBus';
import {ModalEvents} from '../../../../components/style-guide/modal/ModalEvents';
import {
  ContactUsMessageContent
} from '../../../../components/style-guide/modal/components/ContactUsMessage/ContactUsMessageContent';
import docSnapshot from "./preview-icon.svg";
import {isNullOrUndefined} from "../../../../shared";
import ReactTooltip from "react-tooltip";
import {MoreIcon} from "../../../../components/style-guide/icons";
import {Dropdown} from "../../../../components";
import {useSelector} from "react-redux";
import {getCurrentUser} from '../../store/my-reports.selectors';

const handleErrorModal = () => {
  eventBus.dispatch(ModalEvents.OPEN, { content: <ContactUsMessageContent />, className: 'empty-modal-title' })
};

export const DocTile = props => {
  const styleMetaContainer = clsx(styles.metaContainer, 'py-2 px-1');
  const styleMeta = clsx(styles.meta, 'p-1');

  const {
    className,
    src = docSnapshot,
    percentage = 0,
    id,
    documentId,
    mltUid,
    cavUid,   
    patente,
    emitDate,
    statusMsg = null,
    retryFailure,
    tipo_reporte,
    comprobanteUid,
    creator,
    disabled = (percentage >= 0 && percentage < 100) || isNullOrUndefined(documentId),
    handleDownload,
    handlePreview,
    handlePreviewInvoice,
    onDownload = () => handleDownload(documentId, patente, tipo_reporte),
    onPreview = (id) => handlePreview(id),
    ...other
  } = props;

  const currentUser = useSelector(getCurrentUser);
  const currentUserEmail = currentUser.profile?.email || currentUser.username;
  const isMenuDisabled = (isNullOrUndefined(cavUid) && isNullOrUndefined(mltUid) && isNullOrUndefined(comprobanteUid)) || (cavUid === "" && mltUid === "" && comprobanteUid === "");

  return (
    <div className={clsx(styles.docTile, className)} role="option" tabIndex={-1} aria-disabled={false} {...other}>
      <div>
        <div className={clsx(styles.snapshotContainer, { [styles.disabled]: disabled })}>
          <div className={styles.docSnapshot} style={{ backgroundImage: `url(${src})` }} />
        </div>
        <div className={styleMetaContainer}>
          <div className={clsx(styleMeta, { [styles.disabled]: disabled })}>
            <span className={styles.name}>Patente: </span>
            <span className={styles.detail}>{patente}</span>
          </div>
          <div className={clsx(styleMeta, { [styles.disabled]: disabled })}>
            <span className={styles.name}>Emitido: </span>
            <span className={styles.detail}>{emitDate}</span>
          </div>
          <div className={clsx(styleMeta, { [styles.disabled]: disabled })}>
            <span className={styles.name}>Reporte: </span>
            <span className={styles.detail}>{tipo_reporte === 'ANONYMOUS' ? 'Anónimo' : 'Completo'}</span>
          </div>

          <ReactTooltip id='more' backgroundColor="var(--primary)" effect='solid'>
            Más
          </ReactTooltip>

          <ReactTooltip id='previewTooltip' backgroundColor="var(--primary)" effect='solid'>
            Ver Reporte
          </ReactTooltip>

          <ReactTooltip id='downloadTooltip' backgroundColor="var(--primary)" effect='solid'>
            Descargar Reporte
          </ReactTooltip>

          <div className="d-flex">
            <span
              className="mr-auto">
              <Dropdown
                onSelectItem={(item, index) => {
                  if (item.id === 'invoice') {
                    return handlePreviewInvoice(comprobanteUid);
                  }

                  onPreview(item.id === 'cav' ? cavUid : mltUid)
                }}
                disabled={isMenuDisabled}
                align="left"
                items={[
                  { label: "Ver CAV", disabled: isNullOrUndefined(cavUid) || cavUid === "", id: 'cav' },
                  { label: "Ver MLT", disabled: isNullOrUndefined(mltUid) || mltUid === "", id: 'mlt' },
                  { label: "Ver Boleta/Factura", disabled: currentUserEmail !== creator || isNullOrUndefined(comprobanteUid) || comprobanteUid === "", id: 'invoice' }
                ]}>
                <MoreIcon style={{ fontSize: '16px' }} fill="#374151" data-tip data-for='more' />
              </Dropdown>
            </span>

            <span
              className={clsx("p-1 btn-clear", { [styles.disabled]: disabled })}
              onClick={() => onPreview(documentId)}
              data-tip data-for='previewTooltip'>
              <OpenDocIcon style={{ fontSize: '16px' }} fill="#374151" />
            </span>
            <span
              className={clsx("p-1 btn-clear", { [styles.disabled]: disabled })}
              onClick={onDownload} data-tip
              data-for='downloadTooltip'>
              <DownloadDocIcon style={{ fontSize: '16px' }} fill="#374151" />
            </span>
          </div>
        </div>
      </div>
      <div>
        {percentage >= 0 && percentage < 100 && (<Progress className="pt-2" percentage={percentage} />)}
        {statusMsg && percentage < 0 ?
          (

            <label className={clsx('pt-2', styles.errorMessage)}>
              {statusMsg}
              {!retryFailure && ' En breve volveremos a intentarlo.'}
              <a className={clsx('primary btn-clear', styles.contactButton)} onClick={handleErrorModal}> Contáctenos</a>
            </label>

          )
          : (<label className={clsx(styles.progressLabel, "pt-1")}>{statusMsg}</label>)}
      </div>
    </div>
  );
};

DocTile.propTypes = {
  className: PropTypes.string,
  percentage: PropTypes.number,
  documentId: PropTypes.string,
  id: PropTypes.string,
  retryFailure: PropTypes.bool
};

export default DocTile;
